import React, { useEffect, useRef } from 'react';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Action",
  message,
  subtitle,
  confirmText = "Yes",
  cancelText = "No",
  confirmButtonClass = "bg-red-600 hover:bg-red-700",
  isDanger = true
}) => {
  const confirmButtonRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // Focus the confirm button when dialog opens
      setTimeout(() => confirmButtonRef.current?.focus(), 100);
      
      // Handle Enter key to confirm
      const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onConfirm();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          onClose();
        }
      };
      
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [isOpen, onConfirm, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md">
        <div className={`px-6 py-4 rounded-t-xl ${isDanger ? 'bg-red-600' : 'bg-blue-600'}`}>
          <h3 className="text-lg font-semibold text-white">
            {title}
          </h3>
        </div>
        <div className="p-6">
          <p className="text-gray-700 dark:text-gray-300 mb-2">
            {message}
          </p>
          {subtitle && (
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
              {subtitle}
            </p>
          )}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 font-medium"
            >
              {cancelText}
            </button>
            <button
              ref={confirmButtonRef}
              type="button"
              onClick={onConfirm}
              className={`flex-1 px-4 py-2 text-white rounded-lg font-medium ${confirmButtonClass}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
